enum AlphabeticCountriesCodes {
  US = 'US',
  CA = 'CA',
}

const COUNTRY_NAMES: Record<AlphabeticCountriesCodes, string> = {
  [AlphabeticCountriesCodes.US]: 'United States',
  [AlphabeticCountriesCodes.CA]: 'Canada',
};

const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NC',
  'ND',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'DC',
  'WA',
  'WV',
  'WI',
  'WY',
];

const CA_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

export { AlphabeticCountriesCodes, COUNTRY_NAMES, US_STATES, CA_PROVINCES };
